export interface GalleryVideo { id: string; title: string; date: string; views: string; likes: string; description: string }

export const galleryVideos: GalleryVideo[] = [
  {
    id: "9MYR__6WgZY",
    title: "Wilmington Spring RV Show & Expo hosted by Rex & Sons RVs March 20-21 2026",
    date: "3/3/2026",
    views: "60",
    likes: "3",
    description: "Wilmington! It's time for the Spring RV Show & Expo at Rex & Sons RVs — March 20th and 21st 2026 two days only! Score huge savings on New and Used motorhomes and travel trailers.",
  },
  {
    id: "XacpqyYQWuc",
    title: "Forest River Sunseeker LE Class C gas motorhome 2850SLE",
    date: "2/28/2026",
    views: "992",
    likes: "23",
    description: "Forest River Sunseeker LE Class C gas motorhome 2850SLE Ford at Rex & Sons RV — 31' exterior length, private bedroom with queen walk around bed, large slide, auto leveling jacks, and more.",
  },
  {
    id: "nP5eidwlMl4",
    title: "Puma Vista 37PFL Destination Trailer by Forest River RV",
    date: "2/24/2026",
    views: "259",
    likes: "5",
    description: "The Forest River Palomino Puma Vista 37PFL Destination Trailer at Rex & Sons RVs — front living, kitchen island, king bed, washer/dryer prep, and fireplace.",
  },
  {
    id: "mg4IfzafIzg",
    title: "InTech Aucta Willow Twin Bed or Queen Bed Travel Trailer",
    date: "1/26/2026",
    views: "101",
    likes: "3",
    description: "The Willow by InTech Aucta — innovative & spacious travel trailer with all aluminum design, dedicated bathroom, and outside slide out kitchens.",
  },
  {
    id: "5LIoNlEpjLY",
    title: "Now Carrying Sunseeker B+ & Class C's! Quality-built motorhomes ready for your next adventure.",
    date: "1/18/2026",
    views: "177",
    likes: "1",
    description: "Rex & Sons RV now carries Forest River Sunseeker B+ & Class C motorhomes — built for comfort, quality, and adventure.",
  },
  {
    id: "B9EdDmxu7bo",
    title: "RV Rentals for the Holiday Season",
    date: "12/16/2025",
    views: "1.5K",
    likes: "6",
    description: "Rent an RV at Rex & Sons RVs for the Holiday Season to visit family or for more room for guests staying over.",
  },
  {
    id: "99UG84ewqhQ",
    title: "Rockwood Travel Trailer Campers in stock at Rex & Sons RV",
    date: "12/16/2025",
    views: "37",
    likes: "2",
    description: "Rex & Sons is proud to be the NC RV Dealer for Rockwood Towable Campers — quality construction, convenient floor plans, top-quality features.",
  },
  {
    id: "6sRTFobARc0",
    title: "2007 Dynamax TOURING SEDAN 270 FORD D Motor Home Class C - Diesel",
    date: "12/10/2025",
    views: "34",
    likes: "0",
    description: "Used 2007 Dynamax TOURING SEDAN 270 FORD D Motor Home Class C - Diesel walkthrough.",
  },
  {
    id: "1ydBLcij6eI",
    title: "Rent an RV from Rex & Sons RVs",
    date: "12/8/2025",
    views: "334",
    likes: "5",
    description: "Learn more about RV Travel and Renting an RV from Rex & Sons RVs. We rent Motorhomes and Travel Trailer Campers.",
  },
  {
    id: "qy6pJIeGa7w",
    title: "2026 Forest River RV Puma Camping Edition 210RKCE",
    date: "11/7/2025",
    views: "204",
    likes: "1",
    description: "Check out this new under 26ft PUMA 210RKCE Travel Trailer Camper that just arrived in time for the Holidays Camping Season!",
  },
  {
    id: "4VRVoT8f3kE",
    title: "MEMORIAL DAY SALE Wednesday May 21st - Saturday May 24th 2025",
    date: "5/20/2025",
    views: "133",
    likes: "0",
    description: "Come see us for our MEMORIAL DAY SALE — New & Used Van Campers, Class A & Class C Motorhomes, and all sizes of Travel Trailer Campers!",
  },
  {
    id: "kZztzUbCgiw",
    title: "2025 Venture RV Stratus 262VFK Travel Trailer Camper",
    date: "5/20/2025",
    views: "3.5K",
    likes: "31",
    description: "Venture RV Stratus Ultra-Lite travel trailer 262VFK — queen bed, Azdel composite panels, NXG frame technology.",
  },
  {
    id: "VVb1JCLkDtg",
    title: "2026 inTech RV Aucta Sycamore Travel Trailer",
    date: "5/20/2025",
    views: "5.6K",
    likes: "14",
    description: "Experience the freedom of the open road in the inTech Aucta Sycamore — full bathroom, bunk beds, front queen bedroom, convection microwave.",
  },
  {
    id: "fWcAjsHoiM8",
    title: "Rex & Sons RV Grand Opening Celebration",
    date: "3/23/2025",
    views: "111",
    likes: "0",
    description: "THANK YOU to Everyone that came out to our Grand Opening Event! It was special because of you!",
  },
  {
    id: "OYjdAKL8xS8",
    title: "Rex & Sons RV Grand Opening of New Location March 21 and 22 2025",
    date: "3/12/2025",
    views: "6.5K",
    likes: "4",
    description: "Join us for the Grand Opening of Rex & Sons RVs new location in Castle Hayne! Food trucks, tours, free seminars, door prizes, and amazing deals.",
  },
  {
    id: "KAw97KZO1VM",
    title: "2025 Venture RV SportTrek ST251VFK Travel Trailer",
    date: "1/30/2025",
    views: "227",
    likes: "6",
    description: "2025 Venture RV SportTrek ST251VFK Travel Trailer walkthrough at Rex & Sons RV Wilmington, NC.",
  },
];

/** Converts M/D/YYYY gallery dates to ISO 8601 with Eastern offset. */
export function videoUploadDate(date: string): string {
  const [m, d, y] = date.split("/").map(Number);
  return `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}T12:00:00-05:00`;
}

export const videoThumbnail = (id: string) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const videoWatchUrl = (id: string) => `https://www.youtube.com/watch?v=${id}`;
export const videoEmbedUrl = (id: string) => `https://www.youtube.com/embed/${id}`;
